import { Col, Row } from "antd";
import { useCallback, useMemo } from "react";
import { getFormattedCurrency } from "../../../../../../lib/currencyFormatter";
import dayjs from "dayjs";
import { getFormattedPercentage } from "../../../../../../lib/percentageFormatter";
import {
  INTEREST_CALCULATION_METHODS,
  PAYMENT_SCHEDULE_OPTIONS,
} from "../../../../../../lib/constants";
import { IOption } from "../../../../../../types/Option";

type AccountDetailsProps = {
  data: any;
};

export const AccountDetails = ({ data }: AccountDetailsProps) => {
  const getInfoRow = useCallback(
    (label: string, value: string, isLast: boolean = false) => (
      <Row className={`align-center acc-info ${isLast ? "" : "mb-4"}`}>
        <p className="my-0 text-md title acc-info-label pr-2">{label}</p>
        <p className="my-0 text-md acc-info-value elipsis">{value}</p>
      </Row>
    ),
    []
  );

  const interestCalcMethod: string = useMemo(() => {
    const method = INTEREST_CALCULATION_METHODS.find(
      (item: IOption) => item.value === data.interestCalculationMethod
    );

    return method ? method.label : "-";
  }, [data.interestCalculationMethod]);

  const regularPayment: string = useMemo(() => {
    const { paymentSchedule, regularAmount } = data;

    const schedule = PAYMENT_SCHEDULE_OPTIONS.find(
      (item: IOption) => item.value === paymentSchedule
    );

    return schedule && regularAmount
      ? `${getFormattedCurrency(regularAmount)} ${schedule.label.toLowerCase()}`
      : "-";
  }, [data]);

  return (
    <Row className="d-block">
      <h5 className="h h5 mb-6">Account details</h5>
      <Row className="details-content">
        <Col>
          {getInfoRow("Account #", data.accountNumber)}
          {getInfoRow(
            "Beginning Balance",
            getFormattedCurrency(data.beginningPrincipal)
          )}
          {getInfoRow(
            "Beginning Date",
            dayjs(data.beginningDate).format("MMM D, YYYY")
          )}
          {getInfoRow(
            "Interest Rate",
            getFormattedPercentage(data.interestRate),
            true
          )}
        </Col>
        <Col>
          {getInfoRow("Interest Calculation", interestCalcMethod)}
          {getInfoRow("Regular Payment", regularPayment)}
          {getInfoRow("Primary Seller", data.seller, false)}
          {getInfoRow("Primary Buyer", data.buyer, true)}
        </Col>
      </Row>
    </Row>
  );
};
